import Joi from 'joi';

export const schema = Joi.object({
  description: Joi.string().min(1).error(new Error('Descripción es requerida')),
  missingPart: Joi.string().min(1).error(new Error('Campo requerido')),
});
